/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */

import { ViewEncapsulation, Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
    selector: 'bazis-chip',
    template: `<slot></slot>`,
    styleUrls: ['chip.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
})
export class ChipElement implements OnInit {
    @Input() disabled: boolean;

    @Input() fill: 'clear' | 'outline' | 'solid' = 'solid';

    @Input() size: 'small' | '' = '';

    @HostBinding('class') get chipStyle() {
        return {
            [`bazis-chip_${this.fill}`]: true,
            'bazis-chip--disabled': this.disabled,
            [`bazis-chip_${this.size}`]: !!this.size,
        };
    }

    constructor() {}

    ngOnInit(): void {
        this.disabled = this.disabled !== undefined && this.disabled !== false;
    }
}
